import React from 'react';
import CourseTableRow from './CourseTableRow';

const CourseTableBlock = props => {
    const {
        id,
        headline,
        slotConfigs,
        onOptionClick
    } = props;

    const rows = slotConfigs.map((config) => {
        return (
            <CourseTableRow 
                key={config.id}
                choice={config.choice}
                leftovers={config.leftovers}
                onSelectionChanged={ (option) => { onOptionClick(config.id, option) }} />
        );
    });

    return (
        <div className={id}>
            <div className="table">
                <p className="h3">{headline}</p>
                <table className="table">
                    <tbody>
                        {rows}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default CourseTableBlock;